import _regenerator from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { useStore } from 'vuex';
export default {
  name: 'LangSelector',
  props: {
    styles: {
      type: String,
      "default": function _default() {
        return '';
      }
    }
  },
  setup: function setup() {
    var store = useStore();
    var langMap = {
      zh: '中文',
      en: 'English'
    };
    var languageChange = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              localStorage.setItem('locale-language', e.key);
              _context.n = 1;
              return store.dispatch('getLanguage');
            case 1:
              location.reload();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function languageChange(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      languageChange: languageChange,
      langMap: langMap
    };
  }
};